import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { Settings, Users, Building2, Tag, SlidersHorizontal, Hash, Layers } from 'lucide-react';
import { useAuth } from '@/auth/AuthContext';
import { cn } from '@/lib/utils';

export const AdminLayout: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  // FASE DE PROVES (2026-09-08): restriccio isAdminFullAccess desactivada a
  // peticio del client — qualsevol usuari autenticat de l'empresa te accés
  // al Panel Admin mentre dura la fase de proves. Per reactivar, descomentar
  // el bloc de sota.
  // if (!user?.isAdminFullAccess) {
  //   return (
  //     <div className="flex items-center justify-center min-h-[60vh]">
  //       <div className="text-center">
  //         <p className="text-red-500 font-medium">No tens permisos per accedir a aquesta secció</p>
  //       </div>
  //     </div>
  //   );
  // }
  void user;

  const adminNavItems = [
    { icon: Settings, label: 'Dashboard', path: '/admin' },
    { icon: Users, label: 'Usuaris', path: '/admin/users' },
    { icon: Building2, label: 'Empreses', path: '/admin/companies' },
    { icon: Tag, label: 'Marques', path: '/admin/brands' },
    { icon: SlidersHorizontal, label: 'Configuració', path: '/admin/settings' },
    { icon: Hash, label: 'Contadors', path: '/admin/counters' },
    { icon: Layers, label: 'Taules', path: '/admin/types' },
  ];

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="space-y-6">
      {/* Sub-navegación del módulo de administración */}
      <nav className="flex flex-wrap gap-2 border-b border-border pb-3">
        {adminNavItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                active ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted'
              )}
            >
              <Icon className="w-4 h-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
};

export default AdminLayout;
